export const MANAGER_ROLES = ['roManager', 'rwManager'];
export const READ_ONLY_MANAGER_ROLES = ['roManager'];

export function isManagerRole(role) {
  return MANAGER_ROLES.includes(role);
}

export function isReadOnlyManagerRole(role) {
  return READ_ONLY_MANAGER_ROLES.includes(role);
}

/** Role-gated items fail closed when the session role is missing or unknown. */
export function isHiddenForRoles(hiddenForRoles, userRole) {
  return Array.isArray(hiddenForRoles) && hiddenForRoles.length > 0 && (!userRole || hiddenForRoles.includes(userRole));
}
